import PengajuanIndex from "@/components/claim/pengajuan/pengajuanIndex.vue";
import PengajuanAdd from "@/components/claim/pengajuan/pengajuanAdd.vue";
import PengajuanEdit from "@/components/claim/pengajuan/pengajuanEdit.vue";
import PengajuanDetail from "@/components/claim/pengajuan/pengajuanDetail.vue";


let routesPengajuan = [
  {
    path: '', // child default
    name: "pengajuan",
    component: PengajuanIndex
  },
  {
    path: 'add', // child default
    name: "pengajuanAdd",
    component: PengajuanAdd
  },
  {
    path: 'edit/:id', // child default
    name: "pengajuanEdit",
    component: PengajuanEdit
  },
  {
    path: 'detail/:id', // child default
    name: "pengajuanDetail",
    component: PengajuanDetail
  },
  
];

export default routesPengajuan;